// What a client tab shows once its grant is gone (#10718): it ended, expired
// or was replaced. Reopen goes through the open page, as the staff member,
// and comes straight back to the page this tab was on; Go to Finpilot
// returns the tab to home.
import React from "react";
import {
  armAutoOpen,
  clientEnvironmentOpenUrl,
  tabClient,
} from "@/services/clientEnvironment";
import ClientEnvironmentNotice from "./ClientEnvironmentNotice";

const goTo = (url: string): void => {
  window.location.assign(url);
};

interface ClientEnvironmentEndedProps {
  /** Sends the tab to the open page; replaced in stories. */
  go?: (url: string) => void;
  /** Returns the tab to home; replaced in stories. */
  onHome?: () => void;
}

const ClientEnvironmentEnded: React.FC<ClientEnvironmentEndedProps> = ({
  go = goTo,
  onHome,
}) => {
  // The client this tab was in, as it loaded: not whatever another tab has
  // opened since.
  const client = tabClient();
  const here = `${window.location.pathname}${window.location.search}`;
  const reopen = (): void => {
    if (client === null) return;
    // This click is the staff member asking; the open page acts on it
    // without asking again (review 1b M1).
    armAutoOpen(client.organizationId);
    go(clientEnvironmentOpenUrl(client.organizationId, here));
  };
  return (
    <ClientEnvironmentNotice
      title="Your access to this client environment ended"
      onHome={onHome}
      actions={
        client ? (
          <button
            type="button"
            onClick={reopen}
            className="text-sm px-3 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700 break-words cursor-pointer"
          >
            Reopen {client.organizationName}
          </button>
        ) : null
      }
    >
      {client ? null : "Open the client again from Finpilot."}
    </ClientEnvironmentNotice>
  );
};

export default ClientEnvironmentEnded;
